const STATS = [
  { k: "5.0", label: "Google rating" },
  { k: "16+", label: "Five-star reviews" },
  { k: "4", label: "Service lines" },
  { k: "24/7", label: "Online coaching" },
];

export default function Stats() {
  return (
    <section data-testid="stats-section" className="border-y border-white/10 bg-[#0f0f0f]">
      <div className="container-x grid grid-cols-2 md:grid-cols-4">
        {STATS.map((s, i) => (
          <div
            key={s.label}
            className={`p-8 md:p-12 ${
              i !== STATS.length - 1 ? "md:border-r border-white/10" : ""
            } ${i < 2 ? "border-b md:border-b-0 border-white/10" : ""} ${
              i % 2 === 0 ? "border-r md:border-r border-white/10" : ""
            }`}
          >
            <div className="font-display text-5xl md:text-7xl text-white leading-none">
              {s.k}
            </div>
            <div className="text-[11px] tracking-[0.3em] uppercase text-white/50 mt-3">
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
